'use client'

import { ReactNode } from 'react'
import { Text, Navigation, Button } from '@vinted/web-ui'

type Props = {
  title: ReactNode
  icon: React.ComponentProps<typeof Button>['icon']
  prefixAriaLabel?: string
  suffixText?: ReactNode
  testId?: string
  onPrefixClick: () => void
  onSuffixClick?: () => void
}

const FilterModalNavigation = ({
  title,
  icon,
  prefixAriaLabel,
  suffixText,
  testId,
  onPrefixClick,
  onSuffixClick,
}: Props) => {
  return (
    <Navigation
      left={
        <Button
          styling="flat"
          onClick={onPrefixClick}
          icon={icon}
          size="medium"
          testId={testId ? `${testId}-prefix` : undefined}
          aria={{ 'aria-label': prefixAriaLabel }}
        />
      }
      body={<Text as="h2" text={title} type="title" />}
      right={
        !!suffixText && (
          <Button
            styling="flat"
            onClick={onSuffixClick}
            text={<Text as="span" text={suffixText} type="body" theme="amplified" />}
          />
        )
      }
      testId={testId}
    />
  )
}

export default FilterModalNavigation
